var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{style:({
    //background: `#231F20 url('${backgroundSrc}') no-repeat center center`,
    background: "#E6E7E8",
    backgroundSize: 'cover',
    paddingTop: '1rem',
    marginBottom: '1rem',
  })},[_c('v-container',[_c('v-row',[_c('v-col',{staticStyle:{"margin":"0 auto"},attrs:{"md":"3"}},[_c('v-img',{attrs:{"src":"/img/Communitech-Logo_stacked.svg","contain":""}})],1)],1),_c('PageTitle',[_vm._v(_vm._s(_vm.title))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }